'use strict';

import 'components/scroll-fixed-ios';

import lightBox from 'components/light-box';
import './component.scss';
import 'components/button';

import scrollFixedIos from 'components/scroll-fixed-ios';
import template from 'components/template';
import isEnterOrSpacebarPressed from "../complement/isEnterOrSpacebarPressed";

const TRIGGER_CLASS = 'modal-trigger';
const TRIGGER_HOOK = '.' + TRIGGER_CLASS;
const modalDialogFocusToggler = document.documentElement.dataset.modalDialogFocus;
const DATA_DIALOG_CANCEL_SELECTOR = '[data-dialog-cancel]';

// CYT-20614: keep seat radio inputs out of the modal dialog tab order, they are wrapped by an accessible anchor
const axFlightSeatmapToggle = document.documentElement.dataset.accessibilityFlightSeatmap;
const axFlightSeatmapEnabled = axFlightSeatmapToggle && axFlightSeatmapToggle === 'true';

function init()
{
    scrollFixedIos.init();
}

function onEnterKey(event)
{
    const code = event.keyCode ? event.keyCode : event.which;
    if (code === 13) {      // Enter keycode
        event.preventDefault();
    }
}

function onCancel(event)
{
    const code = event.keyCode ? event.keyCode : event.which;
    const key = event.key;

    if (code === 13 || code === 32
        || key === 'Enter' || key === ' ') {
        event.stopImmediatePropagation();
        event.preventDefault();

        const cancelElement = event.target.closest(DATA_DIALOG_CANCEL_SELECTOR);
        if (cancelElement) {
            const checkboxId = cancelElement.getAttribute('for');
            const checkbox = document.getElementById(checkboxId);

            if (checkbox) {
                checkbox.checked = !checkbox.checked;
                checkbox.dispatchEvent(new CustomEvent('change'));
            } else {
                cancelElement.click();
            }
        }
    }
}

function addInputsEventListeners(dialog, preventEnter, lastElement, firstElement)
{
    for (const toggler of dialog.querySelectorAll(DATA_DIALOG_CANCEL_SELECTOR)) {
        toggler.addEventListener('keydown', onCancel);
    }

    if (preventEnter) {
        // Prevent form submit by pressing enter for all address search fields.
        for (const input of dialog.querySelectorAll('input')) {
            input.addEventListener('keydown', onEnterKey);
        }
    }

    if (firstElement) {
        firstElement.addEventListener('keydown', focusLastElement);
    }

    if (lastElement) {
        lastElement.addEventListener('keydown', focusFirstElement);
    }
}

function removeInputsEventListeners(dialog, lastElement, firstElement)
{
    for (const toggler of dialog.querySelectorAll(DATA_DIALOG_CANCEL_SELECTOR)) {
        toggler.removeEventListener('keydown', onCancel);
    }

    for (const input of dialog.querySelectorAll('input')) {
        input.removeEventListener('keydown', onEnterKey);
    }

    if (firstElement) {
        firstElement.removeEventListener('keydown', focusLastElement);
    }

    if (lastElement) {
        lastElement.removeEventListener('keydown', focusFirstElement);
    }
}

function lightboxListener(event)
{
    const closestParent = event.target.closest(DATA_DIALOG_CANCEL_SELECTOR + ',[data-dialog-ok]');
    if (closestParent) {
        let dialogId = closestParent.closest('.modal-dialog-container').previousElementSibling.getAttribute('for');
        document.dispatchEvent(new CustomEvent('modal-dialog:closed', {
            detail: {id: dialogId, confirmed: closestParent.hasAttribute('data-dialog-ok')},
            cancelable: false,
            bubbles: true
        }));
    }
}

function getModalElements(dialog)
{
    const dialogFareOptionsToggler = document.documentElement.dataset.accessibilityFixFareOptionsDialog;
    const modalInputsSelector = dialogFareOptionsToggler
        ? '.modal-dialog-close,input:not([type="hidden"]),button:not([disabled]),.button,select,textarea,a,label[tabindex="0"]'
        : '.modal-dialog-close,input:not([type="hidden"]),.button,select,textarea,a,label[tabindex="0"]';
    const modalInputs = axFlightSeatmapEnabled
        ? Array.from(dialog.querySelectorAll(modalInputsSelector), element =>
            element.matches('input') ? element.closest('a') || element : element)
        : dialog.querySelectorAll(modalInputsSelector);

    if (modalInputs.length > 1) {
        return [modalInputs[0], modalInputs[modalInputs.length - 1]];
    } else if (modalInputs.length === 1) {
        return [modalInputs[0], modalInputs[0]];
    } else {
        return [];
    }
}

function preventDefault(event)
{
    event.preventDefault();
    event.stopImmediatePropagation();
}

function inactivateElements(dialog)
{
    for (let element of dialog.querySelectorAll('.modal-dialog--inactive')) {
        element.addEventListener('click', preventDefault);
    }
}

function reactivateElements(dialog)
{
    for (let element of dialog.querySelectorAll('.modal-dialog--inactive')) {
        element.removeEventListener('click', preventDefault);
    }
}

/**
 * options: {
 *     openOnCreate: bool,
 *     destroyOnClose: bool,
 *     className: String
 * }
 */
function create(name, title, content, options, ok, cancel, trigger)
{
    const o = Object.assign({openOnCreate: false, destroyOnClose: false, className: '', skipEvents: false}, options);
    let buttonTemplate;
    name = name + '-dynamically-created';

    /*
    * If the modal dialog is already created, destroy it before creating the new one with different content
    */
    if (document.getElementById('modal-dialog-wrapper-' + name)) {
        destroy(name);
    }

    if (ok || cancel) {
        buttonTemplate =  `<div class="button-group">${template.render('button-group', {ok: ok, cancel: cancel, name: name})}</div>`;
    }

    const dialogCancelTranslatedText = template.render('dialog-cancel-text', {});
    const dialogCancelAriaLabel = dialogCancelTranslatedText ? dialogCancelTranslatedText : "Close button";

    let html = `<div id="modal-dialog-wrapper-${name}">
  ${lightBox.create(name, 'modal-dialog')}
  <div class="modal-dialog-container${o.className ? ' ' + o.className : ''}" ${o.destroyOnClose ? 'data-destroy-on-close' : ''} ${o.skipEvents ? 'data-skip-events' : ''} role="dialog" aria-modal="true" aria-labelledby="${name}-title">
    <div class="modal-dialog">
      <div class="modal-dialog-view">
        <h2 id="${name}-title" class="modal-dialog--title active-border">
          <div id="modal-dialog-title-${name}">${title ? title : ''}</div>
        </h2>
        <span class="modal-dialog--title-button text--xlarge">
          <label for="${name}-toggler" class="modal-dialog-close" data-dialog-cancel role="button" tabindex="0" aria-label="${dialogCancelAriaLabel}"></label>
        </span>
        <div class="modal-dialog-content" id="modal-dialog-content-${name}" aria-live="assertive">
        </div>
        ${buttonTemplate ? buttonTemplate : ''}
      </div>
    </div>
  </div>
</div>`;

    document.body.insertAdjacentHTML('beforeend', html);

    /*
     * The opening of the modal dialog is before the insert of the content because of not correct rendering on IE 11 - small resolution
     */

    lightBox.init([document.getElementById(`${name}-toggler`)]);

    if (o.openOnCreate) {
        document.dispatchEvent(new CustomEvent('modal-dialog:open', {detail: {id: `${name}-toggler`}}));

        if (modalDialogFocusToggler && trigger) {
            trigger.classList.add(TRIGGER_CLASS);
        }
    }

    let dialog = document.body.lastElementChild,
        dialogContent = document.getElementById(`modal-dialog-content-${name}`);
    if (typeof content === 'string') {
        dialogContent.insertAdjacentHTML('afterbegin', content);
    } else {
        for (let element of content) {
            dialogContent.appendChild(element);
        }
    }

    if (modalDialogFocusToggler) {
        focusElementOnOpen(dialog);
    }

    return dialog;
}

function destroy(name)
{
    let element = document.getElementById('modal-dialog-wrapper-' + name);
    if (element) {
        element.remove();
    }
}

document.addEventListener('modal-dialog:open', event => {
    const input = document.getElementById(event.detail.id);
    if (input && !input.checked) {
        input.click();
    }
});

document.addEventListener('modal-dialog:close', event => {
    const input = document.getElementById(event.detail.id);
    if (input && input.checked) {
        input.click();
    }
});

document.addEventListener('light-box:open', event => {
    const dialog = event.detail,
        okButton = dialog.querySelector('[data-dialog-ok]'),
        modalElements = getModalElements(dialog);
    if (dialog.dataset.skipEvents !== undefined) {
        return;
    }

    addInputsEventListeners(dialog, !okButton, modalElements[1], modalElements[0]);
    inactivateElements(dialog);
    dialog.addEventListener('click', lightboxListener);
    document.documentElement.classList.add('modal-dialog-open');

    if (modalDialogFocusToggler) {
        focusElementOnOpen(dialog);
    } else {
        modalElements[0] && modalElements[0].focus();
    }

    dialog.dispatchEvent(new CustomEvent('modal-dialog:opened', {bubbles: true}));
});

document.addEventListener('light-box:close', event => {
    const dialog = event.detail;

    removeInputsEventListeners(dialog, getModalElements(dialog)[1], getModalElements(dialog)[0]);
    reactivateElements(dialog);
    dialog.removeEventListener('click', lightboxListener);
    document.documentElement.classList.remove('modal-dialog-open');

    if (dialog.dataset.destroyOnClose !== undefined) {
        dialog.parentNode.remove();
    }

    if (modalDialogFocusToggler) {
        focusTogglerLabelAfterModalClose();
    }

    dialog.dispatchEvent(new CustomEvent('modal-dialog:closed', {bubbles: true}));
});

/*
***  Accessibility functionality
*/
function focusElementOnOpen(dialog) {
    const modalElements = getModalElements(dialog);
    modalElements[0] && modalElements[0].focus();
}

function focusFirstElement(event)
{
    let modalDialog = event.target.closest('.modal-dialog-container'),
        modalDialogELements = getModalElements(modalDialog),
        firstFocusableElement = modalDialogELements[0],
        isTabPressed = event.key === 'Tab' || event.which === 9,
        isEnterPressed = event.key=== 'Enter' ||event.which === 13;

    // If 'enter' is pressed return and submit form
    if (isEnterPressed) {
        event.target.classList.remove('focus-visible');
        event.target.removeAttribute('data-focus-visible-added');
        return;
    }

    // if any key, except 'tab' is pressed do nothing and return
    if(!isTabPressed) {
        event.preventDefault();
        return;
    }

    // If shift key is not pressed(for shift + tab combination) focus first focusable element
    if (!event.shiftKey) {
        firstFocusableElement.focus();
        event.preventDefault();
    }
}

function focusLastElement(event)
{
    let modalDialog = event.target.closest('.modal-dialog-container'),
        modalDialogElements = getModalElements(modalDialog),
        lastFocusableElement = modalDialogElements[modalDialogElements.length - 1],
        isTabPressed = event.key === 'Tab' || event.which === 9,
        isShiftPressed = event.key=== 'Shift' || event.which === 16;

    // if any key, except 'tab' or 'shift', is pressed do nothing and return
    if (!isTabPressed || isShiftPressed) {
        // in case there is no "X" button for closing, and there is more than one interactive element in the modal dialog
        if (!event.target.isSameNode(lastFocusableElement) && (event.target.classList.contains("button") || event.target.role === "button")) {
            isEnterOrSpacebarPressed(event) && event.target.click();
        }
        event.preventDefault();
        return;
    }

    // Otherwise check for 'shift' key is pressed for shift + tab combination
    if (event.shiftKey) {
        lastFocusableElement.focus();
        event.preventDefault();
    }
}

function focusTogglerLabelAfterModalClose() {
    const trigger = document.querySelector(TRIGGER_HOOK);

    if (trigger) {
        trigger.focus();
        trigger.classList.remove(TRIGGER_CLASS);
    }
}

export default {init, create, destroy, focusFirstElement};